(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9478],{

/***/ 32036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ Textarea; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@wartek-id/textarea/node_modules/clsx/dist/clsx.m.js
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var clsx_m = (clsx);
// EXTERNAL MODULE: ./node_modules/@wartek-id/react-utils/dist/index.esm.js
var index_esm = __webpack_require__(81725);
;// CONCATENATED MODULE: ./node_modules/@wartek-id/textarea/dist/index.esm.js




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Textarea-module_textarea__2Izl3{--padding-left-input-area:16px;--padding-right-input-area:16px;box-sizing:border-box;font-size:var(--size-font-body);line-height:var(--size-line-height-text-body);font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;padding:12px 16px;background-color:var(--color-white);color:var(--color-text-default);border:1px solid var(--color-border-default);border-radius:var(--size-border-radius-base);outline:none;width:100%;resize:none}.Textarea-module_textarea__2Izl3::-moz-placeholder{color:var(--color-text-disabled)}.Textarea-module_textarea__2Izl3:-ms-input-placeholder{color:var(--color-text-disabled)}.Textarea-module_textarea__2Izl3::placeholder{color:var(--color-text-disabled)}.Textarea-module_textarea__2Izl3.Textarea-module_error__gOCxF:focus,.Textarea-module_textarea__2Izl3:focus{box-shadow:0 0 0 2px var(--color-interactive-focused);border-color:var(--color-interactive-focused)}.Textarea-module_textarea__2Izl3.Textarea-module_disabled__21E2z,.Textarea-module_textarea__2Izl3[aria-disabled=true]{background-color:var(--color-surface-disabled);border-color:var(--color-border-disabled);color:var(--color-text-disabled)}.Textarea-module_textarea__2Izl3.Textarea-module_error__gOCxF{background-color:var(--color-surface-critical-subdued);border-color:var(--color-border-critical-default)}.Textarea-module_helperContainer__1HNT3{display:flex;justify-content:space-between;margin-top:4px}.Textarea-module_helper__3polw{font-size:var(--size-font-helper);font-weight:var(--font-weight-helper);line-height:var(--size-line-height-text-helper);flex-basis:100%}.Textarea-module_helper__3polw.Textarea-module_default__1C2zh{color:var(--color-text-subdued)}.Textarea-module_helper__3polw.Textarea-module_error__gOCxF{color:var(--color-text-critical)}.Textarea-module_helper__3polw.Textarea-module_right__1uXXB{text-align:right}.Textarea-module_helper__3polw+.Textarea-module_right__1uXXB{flex-basis:24px}";
var styles = {"textarea":"Textarea-module_textarea__2Izl3","error":"Textarea-module_error__gOCxF","disabled":"Textarea-module_disabled__21E2z","helperContainer":"Textarea-module_helperContainer__1HNT3","helper":"Textarea-module_helper__3polw","default":"Textarea-module_default__1C2zh","right":"Textarea-module_right__1uXXB","$default$":"Textarea-module_default__1C2zh"};
styleInject(css_248z);

var Textarea = react.forwardRef(function (_a, ref) {
    var _b;
    var className = _a.className, _c = _a.isDisabled, isDisabled = _c === void 0 ? false : _c, _d = _a.isInvalid, isInvalid = _d === void 0 ? false : _d, helperText = _a.helperText, errorMessage = _a.errorMessage, maxLength = _a.maxLength; _a.value; var onChange = _a.onChange, props = __rest(_a, ["className", "isDisabled", "isInvalid", "helperText", "errorMessage", "maxLength", "value", "onChange"]);
    var classes = clsx_m(className, styles.textarea, isDisabled && styles.disabled, !!isInvalid && styles.error);
    var helperId = (0,index_esm/* useId */.Me)();
    var internalRef = react.useRef(null);
    var _e = react.useState(0), inputLength = _e[0], setInputLength = _e[1];
    var handleChange = function (e) {
        setInputLength(e.target.value.length);
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
    };
    var assignRef = function (node) {
        // @ts-expect-error
        internalRef.current = node;
        if (typeof ref === 'function') {
            ref(node);
        }
        else if (ref) {
            ref.current = node;
        }
    };
    // Make input length counter consistent by ready from internalRef
    // Note: we can't use props.defaultValue as it causes the value not
    // displayed on the screen for some reason
    react.useEffect(function () {
        var _a, _b;
        if ((_a = internalRef.current) === null || _a === void 0 ? void 0 : _a.value) {
            var length_1 = String((_b = internalRef.current) === null || _b === void 0 ? void 0 : _b.value).length;
            setInputLength(length_1);
        }
    }, [(_b = internalRef.current) === null || _b === void 0 ? void 0 : _b.value]);
    return (react.createElement("div", { style: { width: '100%', lineHeight: 0 } },
        react.createElement("textarea", __assign({ "aria-disabled": isDisabled, disabled: isDisabled, "aria-invalid": !!isInvalid, className: classes, rows: 5, maxLength: maxLength, onChange: handleChange, "aria-describedby": helperId }, props, { ref: assignRef })),
        (helperText || errorMessage || typeof maxLength !== 'undefined') && (react.createElement("div", { className: styles.helperContainer },
            (helperText || errorMessage) && (react.createElement("span", { id: helperId, className: clsx_m(styles.helper, helperText && styles.default, (!!isInvalid || errorMessage) && styles.error), "aria-live": !!isInvalid ? 'polite' : 'off' }, errorMessage || helperText)),
            typeof maxLength !== 'undefined' && maxLength > 0 && (react.createElement("span", { className: clsx_m(styles.helper, styles.right, helperText && styles.default, errorMessage && styles.error) },
                inputLength,
                "/",
                maxLength))))));
});




/***/ }),

/***/ 18631:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pelatihan-mandiri/topik/[topik]",
      function () {
        return __webpack_require__(67897);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useGetSingleTopicProgress; },
/* harmony export */   "v": function() { return /* binding */ useGetTopicsProgress; }
/* harmony export */ });
/* harmony import */ var utils_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71529);


var basePath = "/microlearnings";
function useGetTopicsProgress(isTriggered) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("".concat(basePath, "/topics/progress"), {
        queryConfig: {
            enabled: isTriggered,
            useErrorBoundary: false
        },
        errorHandlerFn: function(status, path, error) {
            (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .handleCommonErrors */ .CI)(status !== null && status !== void 0 ? status : 500, path, error);
        }
    });
}
function useGetSingleTopicProgress(moduleId, isTriggered) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("".concat(basePath, "/topics/").concat(moduleId, "/progress"), {
        queryConfig: {
            enabled: !!moduleId && isTriggered
        },
        errorHandlerFn: function(status, path, error) {
            (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .handleCommonErrors */ .CI)(status !== null && status !== void 0 ? status : 500, path, error);
        }
    });
}


/***/ }),

/***/ 14644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cz": function() { return /* binding */ useGetTopicAksiNyataSession; },
/* harmony export */   "Ht": function() { return /* binding */ useTriggerGenerateCertificatePdf; },
/* harmony export */   "Lr": function() { return /* binding */ useTopicProgress; },
/* harmony export */   "MD": function() { return /* binding */ useTopicNewest; },
/* harmony export */   "Sw": function() { return /* binding */ useGetTopicDetail; },
/* harmony export */   "TA": function() { return /* binding */ useGetRelevanceTopic; },
/* harmony export */   "Ti": function() { return /* binding */ usePostAksiNyataAppeal; },
/* harmony export */   "W0": function() { return /* binding */ usePostAksiNyata; },
/* harmony export */   "XI": function() { return /* binding */ useGetTopicList; },
/* harmony export */   "YK": function() { return /* binding */ usePostTopicCertificate; },
/* harmony export */   "bJ": function() { return /* binding */ useGetCertificate; },
/* harmony export */   "bt": function() { return /* binding */ useGetAksiNyataRevision; },
/* harmony export */   "gb": function() { return /* binding */ useGetTopicAksiNyataOptions; },
/* harmony export */   "l4": function() { return /* binding */ usePostCertificate; },
/* harmony export */   "nL": function() { return /* binding */ useTopicCertificate; },
/* harmony export */   "oq": function() { return /* binding */ useTopicRecommendation; },
/* harmony export */   "w3": function() { return /* binding */ JenjangUnmatched; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25171);
/* harmony import */ var utils_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71529);
/* harmony import */ var utils_customError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97512);






var JenjangUnmatched = /*#__PURE__*/ function(CustomError) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(JenjangUnmatched, CustomError);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(JenjangUnmatched);
    function JenjangUnmatched(apiPath, originalError) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, JenjangUnmatched);
        var title = "Jenjang tidak sesuai";
        var description = "Topik yang anda akses tidak sesuai dengan jenjang akun anda.";
        return _super.call(this, {
            title: title,
            description: description,
            apiPath: apiPath,
            originalError: originalError
        });
    }
    return JenjangUnmatched;
}(utils_customError__WEBPACK_IMPORTED_MODULE_4__/* .CustomError */ .sH);
function useGetTopicList() {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics", {
        errorHandlerFn: function(status, path, error) {
            (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .handleCommonErrors */ .CI)(status !== null && status !== void 0 ? status : 500, path, error);
        }
    });
}
function useGetTopicDetail(topicId) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId), {
        queryConfig: {
            enabled: !!topicId
        },
        errorHandlerFn: function(status, path, error, errorResponse) {
            var ref, ref1, ref2, ref3;
            if (status === 400 && !!((ref1 = (ref = errorResponse.data) === null || ref === void 0 ? void 0 : ref.errors[0]) === null || ref1 === void 0 ? void 0 : ref1.code) && ((ref3 = (ref2 = errorResponse.data) === null || ref2 === void 0 ? void 0 : ref2.errors[0]) === null || ref3 === void 0 ? void 0 : ref3.code) === "08-118") {
                throw new JenjangUnmatched(path, error);
            } else {
                (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .handleCommonErrors */ .CI)(status !== null && status !== void 0 ? status : 500, path, error);
            }
        }
    });
}
function useGetTopicAksiNyataOptions(topicId, enabled) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata-options"), {
        queryConfig: {
            enabled: !!topicId && enabled
        }
    });
}
function useGetTopicAksiNyataSession(topicId, enabled) {
    var data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata"), {
        queryConfig: {
            enabled: !!topicId && enabled,
            useErrorBoundary: false
        },
        axiosConfig: {
            data: data
        }
    });
}
function usePostAksiNyata(topicId, method, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useMutationApi */ .fy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata"), {
        mutationConfig: opts,
        axiosConfig: {
            method: method
        }
    });
}
function useGetRelevanceTopic(topicId) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/relevances"), {
        queryConfig: {
            useErrorBoundary: false
        }
    });
}
function useGetAksiNyataRevision(topicId, enabled) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata/revision"), {
        queryConfig: {
            enabled: !!topicId && enabled,
            useErrorBoundary: false
        }
    });
}
function usePostCertificate(topicId, method, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useMutationApi */ .fy)("/microlearnings/topics/".concat(topicId, "/certificate"), {
        mutationConfig: opts,
        axiosConfig: {
            method: method
        }
    });
}
function useGetCertificate(param) {
    var enabled = param.enabled, errorHandler = param.errorHandler, refetchInterval = param.refetchInterval, topicId = param.topicId;
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/certificate"), {
        axiosConfig: {
            method: "GET"
        },
        queryConfig: {
            enabled: !!topicId && enabled,
            useErrorBoundary: false,
            refetchInterval: refetchInterval
        },
        errorHandlerFn: function(_status, _path, error, errorResponse) {
            var errorCode = errorResponse.data.errors[0].code;
            errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(errorCode, error);
        }
    });
}
function useTriggerGenerateCertificatePdf(topicId, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useMutationApi */ .fy)("/microlearnings/topics/".concat(topicId, "/certificate/rerender"), {
        mutationConfig: opts,
        axiosConfig: {
            method: "POST"
        }
    });
}
function usePostAksiNyataAppeal(topicId, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useMutationApi */ .fy)("/microlearnings/topics/".concat(topicId, "/aksi-nyata/appeal"), {
        mutationConfig: opts,
        axiosConfig: {
            method: "POST"
        }
    });
}
function useTopicNewest() {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topic-recommendation", {
        queryConfig: {
            useErrorBoundary: false
        }
    });
}
function useTopicRecommendation() {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/section-page", {
        queryConfig: {
            useErrorBoundary: false
        }
    });
}
function useTopicProgress() {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/progress", {
        queryConfig: {
            useErrorBoundary: false
        }
    });
}
function useTopicCertificate(param) {
    var topicId = param.topicId, errorHandler = param.errorHandler;
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useQueryApi */ .Zy)("/microlearnings/topics/".concat(topicId, "/surat-selesai-belajar"), {
        queryConfig: {
            enabled: !!topicId,
            useErrorBoundary: false
        },
        errorHandlerFn: function(_status, _path, error, errorResponse) {
            var errorCode = errorResponse.data.errors[0].code;
            errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(errorCode, error);
        }
    });
}
function usePostTopicCertificate(topicId, opts) {
    return (0,utils_api__WEBPACK_IMPORTED_MODULE_0__/* .useMutationApi */ .fy)("/microlearnings/topics/".concat(topicId, "/surat-selesai-belajar"), {
        mutationConfig: opts,
        axiosConfig: {
            method: "POST"
        }
    });
}


/***/ }),

/***/ 34311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _wartek_id_text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89004);
/* harmony import */ var api_microlearning_useAPIKeyValue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42979);




var InfoUpdatedTopic = function(param) {
    var _parentClass = param.parentClass, parentClass = _parentClass === void 0 ? "" : _parentClass, onUpdated = param.onUpdated, isForceShow = param.isForceShow;
    var ref;
    var getUpdateInfo = (0,api_microlearning_useAPIKeyValue__WEBPACK_IMPORTED_MODULE_2__/* .useGetKeyPairValue */ .q8)(api_microlearning_useAPIKeyValue__WEBPACK_IMPORTED_MODULE_2__/* .MILKvKeys.TopicListUpdateInformation */ .QK.TopicListUpdateInformation, true, {
        staleTime: Infinity
    });
    var data = (ref = getUpdateInfo.data) === null || ref === void 0 ? void 0 : ref.data;
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (data === null || data === void 0 ? void 0 : data.isEnabled) {
            onUpdated === null || onUpdated === void 0 ? void 0 : onUpdated(data.isEnabled);
        }
    }, [
        data === null || data === void 0 ? void 0 : data.isEnabled,
        onUpdated
    ]);
    if (!(data === null || data === void 0 ? void 0 : data.isEnabled) && !isForceShow || getUpdateInfo.isLoading) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-surface-informational-subdued p-4 flex " + parentClass,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mr-3 flex-shrink-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "https://mil-kv.guru.belajar.id/web-assets/img-announcement-speaker.png",
                    height: 32,
                    width: 32,
                    alt: "Info"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                        variant: "body-bold",
                        children: data === null || data === void 0 ? void 0 : data.message
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: data === null || data === void 0 ? void 0 : data.url,
                        className: "mt-1 block",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                            variant: "body",
                            className: "!text-icon-informational underline",
                            children: data === null || data === void 0 ? void 0 : data.action
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InfoUpdatedTopic);


/***/ }),

/***/ 40932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_androidHandler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84494);
/* harmony import */ var components_SocialShareDrawer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70586);





var useShowSocialDrawer = function(params) {
    var androidHandler = (0,utils_androidHandler__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), showShareDrawer = ref[0], setShowShareDrawer = ref[1];
    var toggleDrawer = function() {
        return setShowShareDrawer(function(show) {
            return !show;
        });
    };
    var triggerShareDialog = function() {
        if (androidHandler.enabled) {
            androidHandler.shareToolkitUrl(params.shareText);
        } else {
            toggleDrawer();
        }
    };
    return {
        triggerShareDialog: triggerShareDialog,
        Drawer: function() {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SocialShareDrawer__WEBPACK_IMPORTED_MODULE_2__/* .SocialShareDrawer */ .P, {
                title: params.drawerTitle,
                isOpen: showShareDrawer,
                onClose: toggleDrawer,
                shareUrl: params.shareUrl || window.location.href,
                shareText: params.shareText,
                linkOnlyOnCopy: true
            });
        }
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useShowSocialDrawer);


/***/ }),

/***/ 79210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _wartek_id_text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89004);
/* harmony import */ var app_PelatihanMandiriPage_components_TabbedNav__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18046);
/* provided dependency */ var process = __webpack_require__(83454);






var TopicHeader = function(param) {
    var title = param.title, shouldShowTab = param.shouldShowTab, _shouldShowInfo = param.shouldShowInfo, shouldShowInfo = _shouldShowInfo === void 0 ? true : _shouldShowInfo;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(), pathname = ref.pathname, query = ref.query;
    var baseUrl = process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri";
    var baseHref = "/".concat(baseUrl, "/topik/").concat(query === null || query === void 0 ? void 0 : query.topik);
    var navItems = [
        {
            name: "pelatihan",
            label: "Pelatihan",
            href: baseHref
        },
        {
            name: "referensi",
            label: "Pengayaan",
            href: "".concat(baseHref, "/referensi")
        },
        , 
    ];
    var activeMenu = "pelatihan";
    if (/referensi/.test(pathname)) activeMenu = "referensi";
    var flagShowTab = shouldShowTab;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            shouldShowInfo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("px-4 pb-3 bg-white", !flagShowTab && "shadow-header"),
                variant: "heading-lg",
                children: title
            }),
            flagShowTab && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(app_PelatihanMandiriPage_components_TabbedNav__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                activeMenu: activeMenu,
                navItems: navItems,
                absolutePosition: true,
                className: "relative pt-3"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TopicHeader);


/***/ }),

/***/ 9368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ WebinarPreloader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98743);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97046);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34646);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var dayjs_locale_id__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23260);
/* harmony import */ var dayjs_locale_id__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_id__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86010);
/* harmony import */ var _wartek_id_text__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89004);
/* harmony import */ var _wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28058);
/* harmony import */ var _wartek_id_avatar__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42586);
/* harmony import */ var utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7379);
/* harmony import */ var components_Anchor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55231);
/* harmony import */ var app_PelatihanMandiriPage_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30469);
/* provided dependency */ var process = __webpack_require__(83454);














dayjs__WEBPACK_IMPORTED_MODULE_2___default().extend((dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_3___default()));
dayjs__WEBPACK_IMPORTED_MODULE_2___default().extend((dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_4___default()));
dayjs__WEBPACK_IMPORTED_MODULE_2___default().locale("id");
var WebinarPreloader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative rounded border border-subdued bg-white px-4 py-3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_10__/* .Shimmer */ .q, {
                className: "mb-2",
                height: 14,
                style: {
                    width: "50%"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_10__/* .Shimmer */ .q, {
                className: "mb-4",
                height: 16,
                style: {
                    width: "100%"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_10__/* .Shimmer */ .q, {
                className: "mb-4",
                height: 14,
                style: {
                    width: "100%"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_10__/* .Shimmer */ .q, {
                        className: "mb-4",
                        height: 14,
                        style: {
                            width: "30%"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_10__/* .Shimmer */ .q, {
                        className: "mb-4",
                        height: 14,
                        width: 100
                    })
                ]
            })
        ]
    });
};
var WebinarCard = function(param) {
    var id = param.id, href = param.href, topicName = param.topicName, topicId = param.topicId, title = param.title, speakers = param.speakers, startDate = param.startDate, endDate = param.endDate, _active = param.active, active = _active === void 0 ? false : _active, _isShowNameSpeakers = param.isShowNameSpeakers, isShowNameSpeakers = _isShowNameSpeakers === void 0 ? true : _isShowNameSpeakers;
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().pathname;
    var speakersName = speakers.map(function(speaker) {
        return speaker.name;
    }).join(", ");
    var startDateObj = dayjs__WEBPACK_IMPORTED_MODULE_2___default()(startDate);
    var endDateObj = dayjs__WEBPACK_IMPORTED_MODULE_2___default()(endDate);
    var eventDate = {
        day: startDateObj.format("D"),
        month: startDateObj.format("MMM"),
        time: "".concat(startDateObj.tz("Asia/Jakarta").format("HH:mm"), " - ").concat(endDateObj.tz("Asia/Jakarta").format("HH:mm"), " WIB")
    };
    var AvatarProfile = function(param) {
        var name = param.name, image = param.image, index = param.index;
        if (image) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    transform: "translate(-".concat((index + 1) * 3, "px, 3px)")
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: (0,app_PelatihanMandiriPage_helper__WEBPACK_IMPORTED_MODULE_9__/* .cacheImage */ .qM)(image),
                    alt: name,
                    className: "rounded-full bg-transparent h-9 w-9"
                })
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_avatar__WEBPACK_IMPORTED_MODULE_11__/* .Avatar */ .q, {
            name: name,
            alt: name,
            src: "",
            style: {
                transform: "translate(-".concat((index + 1) * 3, "px,0)")
            }
        }, index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        "data-testid": "webinar",
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("relative rounded border border-subdued bg-white p-3", active && "border-primary bg-blue-20"),
        children: [
            !!topicName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                variant: "eyebrow-sm",
                color: "subdued",
                children: topicName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Anchor__WEBPACK_IMPORTED_MODULE_8__/* .Anchor */ .e, {
                href: href,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    onClick: function() {
                        (0,utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_7__/* .GATrackEvent */ .l)({
                            eventName: "learning_activity",
                            eventParams: {
                                event_trigger: "webinar_list",
                                action_type: pathname === "/".concat(process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/webinar") ? "click_webinar_from_list" : "click_webinar_from_topic",
                                meta: JSON.stringify({
                                    id: id,
                                    title: title,
                                    topik: topicName,
                                    topik_id: topicId
                                })
                            },
                            sendDefaultParams: true
                        });
                    },
                    className: "overlay-link mb-2 block leading-none",
                    href: href,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                        as: "span",
                        variant: "heading-sm",
                        children: title
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mb-3",
                children: isShowNameSpeakers && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                    as: "div",
                    variant: "helper",
                    color: "subdued",
                    className: "leading-none",
                    children: speakersName
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-wrap items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex w-1/2 flex-shrink-0 items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "z-10 flex h-9 w-9 items-center justify-center rounded-full border bg-white",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "py-1",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                                            as: "div",
                                            variant: "body-sm",
                                            className: "text-center leading-none",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                children: eventDate.day
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "-mt-1 text-[8px] font-semibold uppercase",
                                            children: eventDate.month
                                        })
                                    ]
                                })
                            }),
                            speakers.map(function(param, index) {
                                var name = param.name, avatar = param.avatar;
                                return index < 3 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AvatarProfile, {
                                    name: name,
                                    image: avatar,
                                    index: index
                                }) : null;
                            }),
                            speakers.length > 3 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "z-0 flex h-9 w-9 items-center justify-center rounded-full border bg-gray-20",
                                style: {
                                    transform: "translate(-15px,0)"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                                    variant: "body-sm",
                                    className: "text-subdued",
                                    children: [
                                        "+",
                                        speakers.length - 3
                                    ]
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-1/2 flex-shrink-0 flex-grow-0 text-right",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                            variant: "body-sm",
                            color: "subdued",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-semibold",
                                children: eventDate.time
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WebinarCard);


/***/ }),

/***/ 55231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ Anchor; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_androidHandler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84494);






var Anchor = function(props) {
    var href = props.href, children = props.children, linkProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "href",
        "children"
    ]);
    var androidHandler = (0,utils_androidHandler__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)();
    var isAndroid = androidHandler.enabled;
    if (isAndroid) {
        // if children tag is anchor tag, return it
        if (children && typeof children === "object") {
            var child = children;
            if (child.type === "a") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: children
                });
            }
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            href: href
        }, linkProps), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        href: href
    }, linkProps), {
        children: children
    }));
};


/***/ }),

/***/ 72351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S_": function() { return /* binding */ DesktopLayout; },
/* harmony export */   "nc": function() { return /* binding */ WithLayoutListener; }
/* harmony export */ });
/* unused harmony exports useDesktopSubmenuHook, WithDesktopLayout */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _wartek_id_header_bar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89140);
/* harmony import */ var _wartek_id_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21958);
/* harmony import */ var _wartek_id_text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89004);








var PELATIHAN_MANDIRI_PATH = "/pelatihan-mandiri";
var SUB_MENU_TEMPLATE = {
    FOR_YOU: next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(2627), __webpack_require__.e(1547), __webpack_require__.e(7882), __webpack_require__.e(8085), __webpack_require__.e(6315), __webpack_require__.e(2873)]).then(__webpack_require__.bind(__webpack_require__, 86315));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(86315)
                ];
            }
        },
        ssr: false
    }),
    TOPIK: next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(5370), __webpack_require__.e(2627), __webpack_require__.e(4088), __webpack_require__.e(7882), __webpack_require__.e(8085), __webpack_require__.e(2629), __webpack_require__.e(8757)]).then(__webpack_require__.bind(__webpack_require__, 92629));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(92629)
                ];
            }
        },
        ssr: false
    }),
    AKSI_NYATA: next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(2627), __webpack_require__.e(5514), __webpack_require__.e(7882), __webpack_require__.e(9103), __webpack_require__.e(1317)]).then(__webpack_require__.bind(__webpack_require__, 69103)).then(function(template) {
            return template.AksiNyataList;
        });
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(69103)
                ];
            }
        },
        ssr: false
    }),
    MODUL: next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(3303), __webpack_require__.e(5370), __webpack_require__.e(61), __webpack_require__.e(6426), __webpack_require__.e(7034)]).then(__webpack_require__.bind(__webpack_require__, 17422));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(17422)
                ];
            }
        },
        ssr: false
    })
};
var DesktopLayout = function(param) {
    var children = param.children, submenu = param.submenu;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var pathname = router.pathname, query = router.query;
    // TODO: adjust this
    var sideMenu = [
        {
            label: "Seri Pelatihan",
            icon: "book",
            href: "/pelatihan-mandiri",
            active: pathname === "/pelatihan-mandiri" || pathname.includes("/pelatihan-mandiri/seri-pelatihan") || query.from === "learning-series"
        },
        {
            label: "Topik",
            icon: "topic",
            href: "/pelatihan-mandiri/daftar-topik",
            active: pathname === "/pelatihan-mandiri/daftar-topik" || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/modul/[modul]") || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/text/[id]") || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/video/[id]") || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/quiz/[id]") || pathname === "".concat(PELATIHAN_MANDIRI_PATH, "/refleksi/[id]") || pathname.includes("/pelatihan-mandiri/topik/[topik]") && query.from !== "learning-series"
        },
        {
            label: "Webinar",
            icon: "live_tv",
            href: "/pelatihan-mandiri/webinar",
            active: pathname.includes("/pelatihan-mandiri/webinar")
        },
        {
            label: "Aksi nyata",
            icon: "batch_prediction",
            href: "/pelatihan-mandiri/daftar-aksi-nyata",
            active: pathname === "/pelatihan-mandiri/daftar-aksi-nyata" || pathname.includes("/pelatihan-mandiri/aksi-nyata")
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col h-screen w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "fixed w-full p-4 flex flex-row items-center bg-white z-20",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_header_bar__WEBPACK_IMPORTED_MODULE_3__/* .HeaderBarLeftAction */ .l8, {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .J, {
                            as: "i",
                            color: "default",
                            children: "arrow_back"
                        }),
                        onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            router.push("/home")
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_header_bar__WEBPACK_IMPORTED_MODULE_3__/* .HeaderBarTitle */ .rF, {
                        children: "Merdeka Mengajar"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-row bg-gray-10 overflow-hidden h-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col w-64 border-r border-gray-200 mt-[80px] px-4",
                        children: sideMenu.map(function(item, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-row items-center p-2 mt-4 rounded-lg cursor-pointer hover:bg-gray-5 ".concat(item.active ? "bg-gray-20" : ""),
                                onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    router.push(item.href)
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .J, {
                                        as: "i",
                                        color: item.active ? "informational" : "default",
                                        className: "mr-4",
                                        children: item.icon
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                        color: item.active ? "primary" : "default",
                                        variant: "heading-sm",
                                        children: item.label
                                    })
                                ]
                            }, "sidemenu-".concat(index));
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "overflow-y-scroll w-[380px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                            className: "mt-8",
                            children: submenu
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1 overflow-y-scroll p-2 max-w-6xl mx-auto md:px-8 lg:px-16",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                            className: "mt-[80px]",
                            children: children && children
                        })
                    })
                ]
            })
        ]
    });
};
var useDesktopSubmenuHook = function(isDesktop) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var pathname = router.pathname;
    var _query = router.query, id = _query.id, from = _query.from, menuId = _query.menuId, topik = _query.topik;
    if (!isDesktop) return null;
    var SubMenuPageMap = [
        {
            path: "".concat(PELATIHAN_MANDIRI_PATH, "/seri-pelatihan/[id]"),
            components: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.FOR_YOU, {
                    isDesktop: true,
                    currentId: id
                })
            }, "seri-pelatihan-dekstop-submenu")
        },
        {
            path: "".concat(PELATIHAN_MANDIRI_PATH, "/topik/[topik]"),
            components: menuId && from === "learning-series" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.FOR_YOU, {
                    isDesktop: true,
                    currentId: menuId
                })
            }, "topik-desktop-submenu") : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.TOPIK, {
                    isDesktop: true,
                    currentId: topik
                })
            }, "topik-desktop-submenu")
        },
        {
            path: "".concat(PELATIHAN_MANDIRI_PATH, "/daftar-aksi-nyata"),
            components: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.AKSI_NYATA, {
                    isDesktop: true
                })
            }, "daftar-aksi-nyata-desktop-submenu")
        },
        {
            path: "".concat(PELATIHAN_MANDIRI_PATH, "/aksi-nyata/[id]"),
            components: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.AKSI_NYATA, {
                    isDesktop: true
                })
            }, "aksi-nyata-desktop-submenu")
        },
        {
            path: [
                "".concat(PELATIHAN_MANDIRI_PATH, "/modul/[modul]"),
                "".concat(PELATIHAN_MANDIRI_PATH, "/text/[id]"),
                "".concat(PELATIHAN_MANDIRI_PATH, "/video/[id]"),
                "".concat(PELATIHAN_MANDIRI_PATH, "/quiz/[id]"),
                "".concat(PELATIHAN_MANDIRI_PATH, "/refleksi/[id]"), 
            ],
            components: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SUB_MENU_TEMPLATE.MODUL, {})
            }, "modul-desktop-submenu")
        }, 
    ];
    var currentSubMenu = SubMenuPageMap.map(function(subMenu) {
        if (typeof subMenu.path === "string") {
            if (pathname.includes(subMenu.path)) {
                return subMenu.components;
            }
        }
        if (Array.isArray(subMenu.path)) {
            if (subMenu.path.some(function(path) {
                return pathname.includes(path);
            })) {
                return subMenu.components;
            }
        }
    });
    return currentSubMenu;
};
var WithDesktopLayout = function(param) {
    var children = param.children;
    var currentSubMenu = useDesktopSubmenuHook(true);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DesktopLayout, {
        submenu: currentSubMenu,
        children: children
    });
};
var WithLayoutListener = function(param) {
    var children = param.children, isDesktop = param.isDesktop;
    if (isDesktop) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WithDesktopLayout, {
            children: children
        });
    }
    return children;
};


/***/ }),

/***/ 67897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _topik_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-error-boundary/dist/react-error-boundary.umd.js
var react_error_boundary_umd = __webpack_require__(35800);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@wartek-id/header-bar/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(89140);
// EXTERNAL MODULE: ./node_modules/@wartek-id/icon/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(21958);
// EXTERNAL MODULE: ./node_modules/@wartek-id/fe-toolbox/dist/history.mjs
var dist_history = __webpack_require__(72955);
// EXTERNAL MODULE: ./components/ErrorBoundary/index.tsx + 2 modules
var ErrorBoundary = __webpack_require__(71130);
// EXTERNAL MODULE: ./api/microlearning/useAPITopics.ts
var useAPITopics = __webpack_require__(14644);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/Layout/index.ts + 1 modules
var Layout = __webpack_require__(8008);
// EXTERNAL MODULE: ./components/EmptyState/index.ts + 1 modules
var EmptyState = __webpack_require__(99270);
// EXTERNAL MODULE: ./hooks/useSafeRouter.ts
var useSafeRouter = __webpack_require__(28873);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/components/PelatihanErrorFallback.tsx
/* provided dependency */ var process = __webpack_require__(83454);








function PelatihanErrorFallback(param) {
    var error = param.error, resetErrorBoundary = param.resetErrorBoundary;
    var router = (0,next_router.useRouter)();
    var safeReplace = (0,useSafeRouter/* useSafeRouter */._)().safeReplace;
    // @ts-expect-error error is not an Error object
    var title = error.title, description = error.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* LayoutWithHeader */.d, {
        title: "",
        onClickBack: function() {
            return dist_history/* backToApp */.NU(function() {
                resetErrorBoundary();
                router.back();
            });
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyState */.ub, {
                title: title,
                description: description,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyStateAction */.Px, {
                    color: "black",
                    onClick: function() {
                        safeReplace("/".concat(process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri"));
                    },
                    children: "Kembali ke daftar Topik"
                })
            })
        ]
    });
}
/* harmony default export */ var components_PelatihanErrorFallback = (PelatihanErrorFallback);

// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(68430);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@wartek-id/text/dist/index.esm.js + 1 modules
var text_dist_index_esm = __webpack_require__(89004);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/helper.tsx + 1 modules
var helper = __webpack_require__(30469);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./api/microlearning/useAPIProgress.ts
var useAPIProgress = __webpack_require__(38634);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/hooks/useTopicDetails.tsx





var useTopicDetails = function(topicId) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var topicDetail = (0,useAPITopics/* useGetTopicDetail */.Sw)(topicId);
    var topicProgress = (0,useAPIProgress/* useGetSingleTopicProgress */.F)(topicId, topicDetail.isSuccess);
    var aksiNyataRevision = (0,useAPITopics/* useGetAksiNyataRevision */.bt)(topicId, ((ref = topicProgress.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.aksiNyata) === null || ref2 === void 0 ? void 0 : ref2.state) === "NEED_REVISION");
    var ref16 = (0,react.useState)("idle"), fetchStatus = ref16[0], setFetchStatus = ref16[1];
    var ref17 = (0,react.useState)([]), moduleWithProgress = ref17[0], setModuleWithProgress = ref17[1];
    var determineBadgeText = function(moduleProgression) {
        var badgeText;
        if (!(moduleProgression === null || moduleProgression === void 0 ? void 0 : moduleProgression.material) && (moduleProgression === null || moduleProgression === void 0 ? void 0 : moduleProgression.prerequisiteCompleted)) {
            badgeText = "Pelajari Materi";
        } else if ((moduleProgression === null || moduleProgression === void 0 ? void 0 : moduleProgression.material) && (moduleProgression === null || moduleProgression === void 0 ? void 0 : moduleProgression.prerequisiteCompleted) && (moduleProgression === null || moduleProgression === void 0 ? void 0 : moduleProgression.postTest) !== "passed") {
            badgeText = (moduleProgression === null || moduleProgression === void 0 ? void 0 : moduleProgression.postTest) === "not_started" ? "Kerjakan Post Test" : "Kerjakan Ulang Post Test";
        }
        return badgeText;
    };
    /**
   * For modules, progression data is a hard requirement
   * to determine if the module is accessible
   * so first we try to fetch the module list which is inside the topic details
   * and then if succeeded, fetch the module's progression data
   * bail out if any of the query error
   * and set the error status accordingly
   */ (0,react.useEffect)(function() {
        if (topicDetail.isLoading || topicProgress.isLoading || aksiNyataRevision.isLoading) {
            setFetchStatus("loading");
        }
        if (topicDetail.isError || topicProgress.isError || aksiNyataRevision.isError) {
            setFetchStatus("error");
        }
        if (topicDetail.isSuccess && topicProgress.isSuccess) {
            var ref, ref1, ref2;
            if (((ref = topicProgress.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.aksiNyata) === null || ref2 === void 0 ? void 0 : ref2.state) === "NEED_REVISION") {
                if (aksiNyataRevision.isSuccess) setFetchStatus("success");
            } else {
                setFetchStatus("success");
            }
        }
    }, [
        topicDetail.isLoading,
        topicDetail.isError,
        topicDetail.isSuccess,
        topicProgress.isLoading,
        topicProgress.isError,
        topicProgress.isSuccess,
        (ref3 = topicProgress.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.aksiNyata) === null || ref5 === void 0 ? void 0 : ref5.state,
        aksiNyataRevision.isLoading,
        aksiNyataRevision.isError,
        aksiNyataRevision.isSuccess, 
    ]);
    (0,react.useEffect)(function() {
        if (topicDetail.isSuccess && topicProgress.isSuccess) {
            setModuleWithProgress(function() {
                var ref;
                return (ref = topicDetail.data) === null || ref === void 0 ? void 0 : ref.data.modules.map(function(module) {
                    var ref;
                    var moduleProgression = (ref = topicProgress.data.data.modules.find(function(progress) {
                        return progress.moduleId === module.id;
                    })) !== null && ref !== void 0 ? ref : undefined;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, module), {
                        progress: moduleProgression,
                        badgeText: determineBadgeText(moduleProgression)
                    });
                });
            });
        }
    }, [
        topicDetail.isSuccess,
        (ref6 = topicDetail.data) === null || ref6 === void 0 ? void 0 : ref6.data.modules,
        topicProgress.isSuccess,
        (ref7 = topicProgress.data) === null || ref7 === void 0 ? void 0 : ref7.data.modules, 
    ]);
    var ref18;
    return {
        fetchStatus: fetchStatus,
        moduleWithProgress: moduleWithProgress,
        topicData: (ref8 = topicDetail.data) === null || ref8 === void 0 ? void 0 : ref8.data,
        progressionData: (ref9 = topicProgress.data) === null || ref9 === void 0 ? void 0 : ref9.data,
        revisionItems: (ref10 = aksiNyataRevision.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.data) === null || ref11 === void 0 ? void 0 : ref11.revisionItems,
        certifiable: (ref12 = topicProgress.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.meta) === null || ref13 === void 0 ? void 0 : ref13.certifiable,
        appeal: (ref18 = (ref14 = aksiNyataRevision.data) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.data) === null || ref15 === void 0 ? void 0 : ref15.appeal) !== null && ref18 !== void 0 ? ref18 : {},
        refetchProgress: topicProgress.refetch
    };
};
/* harmony default export */ var hooks_useTopicDetails = (useTopicDetails);

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/querystring-es3/index.js
var querystring_es3 = __webpack_require__(97334);
// EXTERNAL MODULE: ./node_modules/@wartek-id/badge/dist/index.esm.js + 1 modules
var badge_dist_index_esm = __webpack_require__(10418);
// EXTERNAL MODULE: ./node_modules/@wartek-id/toast/dist/index.esm.js + 1 modules
var toast_dist_index_esm = __webpack_require__(55086);
// EXTERNAL MODULE: ./utils/hooks/context/useScreenSizeContext.tsx + 1 modules
var useScreenSizeContext = __webpack_require__(65260);
// EXTERNAL MODULE: ./utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__(7379);
// EXTERNAL MODULE: ./types/microlearning.ts
var microlearning = __webpack_require__(69384);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/AksiNyata/AksiNyataCard.tsx
/* provided dependency */ var AksiNyataCard_process = __webpack_require__(83454);












var NeedRevisionCard = function(param) {
    var name = param.name, aksiNyataUrl = param.aksiNyataUrl, onCardClick = param.onCardClick, selectedOptionTitle = param.selectedOptionTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": "aksinyata-card",
        className: "py-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                        variant: "heading-md",
                        children: "Aksi Nyata"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                        variant: "body",
                        color: "subdued",
                        children: "Praktikkan pemahaman terhadap topik ini"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex p-4 w-full mb-3 bg-white rounded border border-subdued hover:cursor-pointer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-8 h-8 rounded-full flex flex-grow-0 flex-shrink-0 items-center justify-center bg-warning",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                            "data-testid": "completed_indicator",
                            as: "i",
                            color: "inverse",
                            fontSize: "small",
                            className: "!text-base !leading-4",
                            children: "border_color"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ml-4 flex-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-[2px] leading-tight",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                    "data-testid": "card-link",
                                    "data-card-url": aksiNyataUrl,
                                    onClick: function() {
                                        onCardClick(aksiNyataUrl);
                                    },
                                    className: "overlay-link cursor-pointer",
                                    variant: "heading-md",
                                    children: name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                        className: "line-clamp-1",
                                        as: "span",
                                        variant: "body-sm",
                                        color: "subdued",
                                        children: selectedOptionTitle
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_dist_index_esm/* Badge */.C, {
                                    "data-testid": "aksinyata-status",
                                    variant: "warning",
                                    children: "Perbaiki Aksi Nyata"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var AksiNyataCard = function(param) {
    var topikId = param.topikId, name = param.name, optionsAmount = param.optionsAmount, selectedOptionTitle = param.selectedOptionTitle, _aksiNyataId = param.aksiNyataId, aksiNyataId = _aksiNyataId === void 0 ? null : _aksiNyataId, _isLocked = param.isLocked, isLocked = _isLocked === void 0 ? true : _isLocked, _aksiNyataSessionState = param.aksiNyataSessionState, aksiNyataSessionState = _aksiNyataSessionState === void 0 ? microlearning/* AksiNyataSessionState.Undetermined */.OZ.Undetermined : _aksiNyataSessionState;
    var ref = (0,react.useState)(""), aksiNyataUrl = ref[0], setAksiNyataUrl = ref[1];
    var isDesktop = (0,useScreenSizeContext/* useScreenSizeContext */.fl)().isDesktop;
    var isOnAppeal = aksiNyataSessionState === microlearning/* AksiNyataSessionState.Appeal */.OZ.Appeal;
    var router = (0,next_router.useRouter)();
    var toast = (0,toast_dist_index_esm/* useToast */.pm)();
    (0,react.useEffect)(function() {
        var cardUrl = "";
        switch(aksiNyataSessionState){
            case "NOT_CREATED":
                cardUrl = "/".concat(AksiNyataCard_process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/topik/").concat(topikId, "/aksi-nyata?").concat((0,querystring_es3.stringify)({
                    topik_name: name
                }));
            case "CREATED":
                cardUrl = "/".concat(AksiNyataCard_process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/topik/").concat(topikId, "/aksi-nyata?").concat((0,querystring_es3.stringify)({
                    topik_name: name
                }));
                break;
            case "NEED_REVISION":
            case "APPEAL":
            case "CONFIRMED":
                cardUrl = "/".concat(AksiNyataCard_process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/topik/").concat(topikId, "/aksi-nyata/form?").concat((0,querystring_es3.stringify)({
                    topik_name: name
                }));
                break;
            case "VALIDATED":
            case "COMPLETED":
                cardUrl = "/".concat(AksiNyataCard_process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/aksi-nyata/").concat(aksiNyataId, "?") + (0,querystring_es3.stringify)({
                    topik_name: name,
                    topik_id: topikId
                });
                break;
        }
        setAksiNyataUrl(cardUrl);
    }, [
        aksiNyataId,
        aksiNyataSessionState,
        name,
        topikId
    ]);
    if (aksiNyataSessionState === "NEED_REVISION") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NeedRevisionCard, {
            aksiNyataUrl: aksiNyataUrl,
            name: name,
            onCardClick: function(url) {
                return router.push(url);
            },
            selectedOptionTitle: selectedOptionTitle
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": "aksinyata-card",
        className: "py-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                        variant: "heading-md",
                        children: "Aksi Nyata"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                        variant: "body",
                        color: "subdued",
                        children: "Praktikkan pemahaman terhadap topik ini"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: isDesktop ? "grid grid-cols-2 gap-2" : null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("relative flex p-4 w-full mb-3 bg-white rounded border border-subdued", "hover:cursor-pointer"),
                    onClick: isOnAppeal ? function() {
                        toast({
                            message: "Aksi Nyata Anda masih dalam proses pengajuan banding"
                        });
                    } : null,
                    children: [
                        [
                            "COMPLETED",
                            "VALIDATED",
                            "APPEAL"
                        ].includes(aksiNyataSessionState) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-8 h-8 rounded-full flex flex-grow-0 flex-shrink-0 items-center justify-center bg-surface-success-default",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-5 h-5 rounded-full flex items-center justify-center bg-icon-success",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                                    "data-testid": "completed_indicator",
                                    as: "i",
                                    color: "inverse",
                                    fontSize: "small",
                                    children: "check"
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex-grow-0 flex-shrink-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)("flex justify-center items-center w-8 h-8 rounded-full overflow-hidden", "bg-expressive-dark-blue text-white"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                                    "data-testid": "unlocked_indicator",
                                    as: "i",
                                    color: "inverse",
                                    fontSize: "small",
                                    children: "batch_prediction"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "ml-4 flex-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-[2px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                        "data-testid": "card-link",
                                        "data-card-url": aksiNyataUrl,
                                        onClick: function() {
                                            (0,googleAnalytics/* GATrackEvent */.l)({
                                                eventName: "learning_activity",
                                                eventParams: {
                                                    event_trigger: "click_aksi_nyata",
                                                    action_type: [
                                                        "COMPLETED",
                                                        "VALIDATED",
                                                        "APPEAL", 
                                                    ].includes(aksiNyataSessionState) ? "view_aksi_nyata" : "do_aksi_nyata",
                                                    meta: JSON.stringify({
                                                        topik_id: topikId
                                                    })
                                                },
                                                sendDefaultParams: true
                                            });
                                            router.push(aksiNyataUrl);
                                        },
                                        className: (0,clsx_m/* default */.Z)("overlay-link cursor-pointer", isOnAppeal && "pointer-events-none"),
                                        variant: "body-sm",
                                        children: "Aksi Nyata"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-[2px] leading-tight",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                        variant: "heading-md",
                                        children: name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        aksiNyataSessionState === "NOT_CREATED" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                                            className: "mr-2",
                                            as: "i",
                                            color: "default",
                                            fontSize: "small",
                                            children: "batch_prediction"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                                className: "line-clamp-1",
                                                as: "span",
                                                variant: "body-sm",
                                                color: "subdued",
                                                children: !!selectedOptionTitle && !isLocked ? selectedOptionTitle : "".concat(optionsAmount, " pilihan Aksi Nyata")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-3",
                                    children: [
                                        isLocked && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_dist_index_esm/* Badge */.C, {
                                            children: "Lihat Pilihan Aksi Nyata"
                                        }),
                                        !isLocked && ![
                                            "COMPLETED",
                                            "VALIDATED",
                                            "APPEAL"
                                        ].includes(aksiNyataSessionState) && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_dist_index_esm/* Badge */.C, {
                                            "data-testid": "aksinyata-status",
                                            variant: "informational",
                                            children: aksiNyataSessionState === "NOT_CREATED" ? "Pilih Aksi Nyata" : aksiNyataSessionState === "CREATED" ? "Lengkapi Lembar Aksi Nyata" : "Kumpulkan Lembar Aksi Nyata"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var AksiNyata_AksiNyataCard = (AksiNyataCard);

// EXTERNAL MODULE: ./utils/datetime.ts + 1 modules
var datetime = __webpack_require__(1413);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Module/ModuleCard.tsx









var ModuleCard = function(param) {
    var id = param.id, number = param.number, name = param.name, duration = param.duration, totalMaterial = param.totalMaterial, href = param.href, badgeText = param.badgeText, _isLocked = param.isLocked, isLocked = _isLocked === void 0 ? false : _isLocked, _isCompleted = param.isCompleted, isCompleted = _isCompleted === void 0 ? false : _isCompleted;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex relative p-4 w-full mb-3 bg-white rounded border border-subdued h-[100%]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-grow-0 flex-shrink-0",
                children: !!isCompleted ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-testid": "completed-indicator",
                    className: "w-8 h-8 rounded-full flex items-center justify-center bg-surface-success-default",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-5 h-5 rounded-full flex items-center justify-center bg-icon-success",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                            as: "i",
                            color: "inverse",
                            fontSize: "small",
                            children: "check"
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("flex justify-center items-center w-8 h-8 rounded-full overflow-hidden", isLocked ? "bg-icon-disabled" : "bg-informational text-white"),
                    children: isLocked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                        "data-testid": "locked-indicator",
                        as: "i",
                        fontSize: "small",
                        children: "lock"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: number
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ml-4 flex-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_dist_index_esm/* Text */.x, {
                            variant: "body-sm",
                            color: isLocked ? "disabled" : "default",
                            children: [
                                "Modul ",
                                number
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)(!isCompleted && "mb-2"),
                        children: isLocked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                            variant: "heading-md",
                            color: "disabled",
                            children: name
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: href,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                "data-module-id": id,
                                href: href,
                                className: "overlay-link",
                                as: "a",
                                variant: "heading-md",
                                onClick: function() {
                                    (0,googleAnalytics/* GATrackEvent */.l)({
                                        eventName: "learning_activity",
                                        eventParams: {
                                            event_trigger: "module_click_from_topik_page",
                                            action_type: "choose_module",
                                            meta: JSON.stringify({
                                                module_id: id
                                            })
                                        },
                                        sendDefaultParams: true
                                    });
                                },
                                children: name
                            })
                        })
                    }),
                    !isCompleted && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex -mx-2 mb-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center px-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                                        as: "i",
                                        color: isLocked ? "disabled" : "default",
                                        fontSize: "small",
                                        children: "access_time"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "ml-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                            as: "span",
                                            variant: "body-sm",
                                            color: "subdued",
                                            children: (0,datetime/* minuteToHour */.ps)(duration)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center px-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                                        as: "i",
                                        color: isLocked ? "disabled" : "default",
                                        fontSize: "small",
                                        children: "book"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "ml-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_dist_index_esm/* Text */.x, {
                                            as: "span",
                                            variant: "body-sm",
                                            color: "subdued",
                                            children: [
                                                totalMaterial,
                                                " materi"
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    !!badgeText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_dist_index_esm/* Badge */.C, {
                            variant: badgeText.toLowerCase() !== "kerjakan ulang post test" ? "informational" : "warning",
                            children: badgeText
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Module_ModuleCard = (ModuleCard);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@wartek-id/shimmer/dist/index.esm.js + 1 modules
var shimmer_dist_index_esm = __webpack_require__(28058);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Module/ModulePlaceholder.tsx




var ModulePlaceholder = function(param) {
    var _amount = param.amount, amount = _amount === void 0 ? 1 : _amount;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "alert",
        "aria-busy": "true",
        children: (0,_to_consumable_array/* default */.Z)(Array(amount)).map(function(_, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex relative p-4 w-full mb-3 bg-white rounded border border-subdued",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-grow-0 flex-shrink-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                            width: 36,
                            height: 36,
                            rounded: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ml-4 flex-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                    className: "mb-2",
                                    style: {
                                        width: "100%"
                                    },
                                    height: 16
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-[8px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                    style: {
                                        width: "100%"
                                    },
                                    height: 18
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex -mx-2 mb-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center px-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "ml-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                                width: 36,
                                                height: 16
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center px-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "ml-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                                width: 36,
                                                height: 16
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-wrap justify-between -mx-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center px-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                            style: {
                                                width: "100%"
                                            },
                                            height: 18
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                                            width: 92,
                                            height: 18
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ var Module_ModulePlaceholder = (ModulePlaceholder);

;// CONCATENATED MODULE: ./assets/icons/check-fat.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCheckFat = function SvgCheckFat(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M8.33341 1.5L3.75008 6.08333L1.66675 4",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var check_fat = (SvgCheckFat);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Topic/ProgressionBar.tsx






var ProgressionIndicator = function(param) {
    var _currentStep = param.currentStep, currentStep = _currentStep === void 0 ? 1 : _currentStep, _threshold = param.threshold, threshold = _threshold === void 0 ? 1 : _threshold;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-testid": currentStep > threshold ? "done" : currentStep === threshold ? "current" : "not started",
        className: (0,clsx_m/* default */.Z)("flex items-center justify-center mb-2 w-5 h-5 rounded-full", currentStep > threshold ? "bg-icon-success" : currentStep === threshold ? "bg-gray-5 border-2 border-interactive-focused" : "bg-gray-5 border-2 border-gray-20"),
        children: currentStep > threshold ? /*#__PURE__*/ (0,jsx_runtime.jsx)(check_fat, {}) : currentStep === threshold ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-3 h-3 bg-interactive-focused rounded-full",
            children: "\xa0"
        }) : null
    });
};
var ProgressionBar = function(param) {
    var progressData = param.progressData;
    var ref = (0,react.useState)(1), currentStep = ref[0], setCurrentStep = ref[1];
    var ref1 = (0,react.useState)(1), currentValueText = ref1[0], setCurrentValueText = ref1[1];
    var currentTopicState = (0,helper/* determineTopicState */.h6)(progressData);
    (0,react.useEffect)(function() {
        var step, valueText;
        switch(currentTopicState){
            default:
            case "DEFAULT":
                step = 1;
                valueText = "Mulai Modul";
                break;
            case "MODULE_ON_PROGRESS":
                step = 2;
                valueText = "Modul Selesai";
                break;
            case "AKSI_NYATA_CREATED":
            case "AKSI_NYATA_ON_PROGRESS":
            case "MODULE_DONE":
                step = 3;
                valueText = "Praktik Aksi Nyata";
                break;
            case "AKSI_NYATA_DONE":
                step = 5;
                valueText = "Pelatihan Selesai";
                break;
        }
        setCurrentValueText(valueText);
        setCurrentStep(step);
    }, [
        currentTopicState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            role: "progressbar",
            "aria-valuemax": 5,
            "aria-valuemin": 1,
            "aria-valuenow": currentStep,
            "aria-valuetext": "".concat(currentValueText),
            className: "relative w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "absolute flex flex-wrap justify-center w-16 -ml-8 left-0 top-0 z-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressionIndicator, {
                            currentStep: currentStep,
                            threshold: 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                            className: "w-full text-center",
                            as: "div",
                            variant: "helper",
                            children: "Mulai Modul"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("absolute w-1/3 ml-1.5 left-0 top-2 h-[2px] z-0", currentStep > 1 ? "bg-gray-50" : "bg-gray-30"),
                    children: "\xa0"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "absolute flex flex-wrap justify-center w-16 -ml-8 left-1/3 top-0 z-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressionIndicator, {
                            currentStep: currentStep,
                            threshold: 2
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                            className: "w-full text-center",
                            as: "div",
                            variant: "helper",
                            children: "Modul Selesai"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("absolute w-1/3 ml-1.5 left-1/3 top-2 h-[2px] z-0", currentStep > 2 ? "bg-gray-50" : "bg-gray-30"),
                    children: "\xa0"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "absolute flex flex-wrap justify-center w-16 -ml-8 left-2/3 top-0 z-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressionIndicator, {
                            currentStep: currentStep,
                            threshold: 3
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                            className: "w-full text-center",
                            as: "div",
                            variant: "helper",
                            children: "Praktik Aksi Nyata"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("absolute w-1/3 ml-1.5 left-2/3 top-2 h-[2px] z-0", currentStep > 3 ? "bg-gray-50" : "bg-gray-30"),
                    children: "\xa0"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "absolute flex flex-wrap justify-center w-16 right-0 -mr-8 top-0 z-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressionIndicator, {
                            currentStep: currentStep,
                            threshold: 4
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                            className: "w-full text-center",
                            as: "div",
                            variant: "helper",
                            children: "Pelatihan Selesai"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Topic_ProgressionBar = (ProgressionBar);

// EXTERNAL MODULE: ./app/PelatihanMandiriPage/partials/Topic/TopicHeader.tsx
var TopicHeader = __webpack_require__(79210);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/components/GenericList.tsx
var GenericList = __webpack_require__(11145);
// EXTERNAL MODULE: ./api/microlearning/useAPIKeyValue.ts
var useAPIKeyValue = __webpack_require__(42979);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/partials/Webinar/WebinarCard.tsx
var WebinarCard = __webpack_require__(9368);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@wartek-id/button/dist/index.esm.js + 1 modules
var button_dist_index_esm = __webpack_require__(54204);
;// CONCATENATED MODULE: ./node_modules/@wartek-id/link/node_modules/clsx/dist/clsx.m.js
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var dist_clsx_m = (clsx);
// EXTERNAL MODULE: ./node_modules/@wartek-id/react-primitive/dist/index.esm.js
var react_primitive_dist_index_esm = __webpack_require__(5144);
;// CONCATENATED MODULE: ./node_modules/@wartek-id/link/dist/index.esm.js




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Link-module_link__3cgLW{background-color:transparent;position:relative;text-underline-offset:1px;padding:2px 4px;text-decoration:none;outline:0}.Link-module_link__3cgLW:before{position:absolute;content:\"\";top:-6px;right:-6px;left:-6px;bottom:-6px}@media (min-width:768px){.Link-module_link__3cgLW{position:static}.Link-module_link__3cgLW:before{display:none}}.Link-module_link__3cgLW:hover{text-decoration:underline}.Link-module_link__3cgLW:focus{border-radius:var(--size-border-radius-base);box-shadow:0 0 0 2px var(--color-interactive-focused)}.Link-module_primary__1Q5Il{color:var(--color-interactive-default)}.Link-module_secondary__2lYZt{color:var(--color-text-default)}.Link-module_white__3Segi{color:var(--color-text-inverse)}.Link-module_disabled__3wlqh{color:var(--color-text-disabled);text-decoration:none;pointer-events:none}.Link-module_underline__1UlaE{text-decoration:underline}.Link-module_underline__1UlaE:hover{text-decoration:none}.Link-module_biggerTapArea__30M-O{padding:8px 4px}";
var styles = {"link":"Link-module_link__3cgLW","primary":"Link-module_primary__1Q5Il","secondary":"Link-module_secondary__2lYZt","white":"Link-module_white__3Segi","disabled":"Link-module_disabled__3wlqh","underline":"Link-module_underline__1UlaE","biggerTapArea":"Link-module_biggerTapArea__30M-O"};
styleInject(css_248z);

var DESCRIPTION_NAME = 'Link';
var DESCRIPTION_DEFAULT_TAG = 'a';
var Link = react.forwardRef(function (props, ref) {
    var _a = props.as, as = _a === void 0 ? DESCRIPTION_DEFAULT_TAG : _a, className = props.className, target = props.target, _b = props.variant, variant = _b === void 0 ? 'primary' : _b, children = props.children, _c = props.underline, underline = _c === void 0 ? true : _c, _d = props.disabled, disabled = _d === void 0 ? false : _d, linkProps = __rest(props, ["as", "className", "target", "variant", "children", "underline", "disabled"]);
    var classes = dist_clsx_m(styles.link, styles[variant], underline && styles.underline, disabled && styles.disabled, className);
    return (react.createElement(react_primitive_dist_index_esm/* Primitive */.WV, __assign({ type: "a", className: classes, target: target, as: as, "aria-disabled": disabled }, linkProps), children));
});
Link.displayName = DESCRIPTION_NAME;



// EXTERNAL MODULE: ./node_modules/@wartek-id/sheet/dist/index.esm.js + 3 modules
var sheet_dist_index_esm = __webpack_require__(34088);
// EXTERNAL MODULE: ./utils/text.ts + 1 modules
var utils_text = __webpack_require__(40999);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Certificate/CertificateSheet/RevisionSheet.tsx








var RevisionSheet = function(param) {
    var isAppealEligible = param.isAppealEligible, isOpen = param.isOpen, onClickAppeal = param.onClickAppeal, onClickFix = param.onClickFix, revisionMessage = param.revisionMessage, setIsOpen = param.setIsOpen;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isAppealClicked = ref[0], setAppealClicked = ref[1];
    react.useEffect(function() {
        if (isAppealClicked) setAppealClicked(false);
    }, [
        isAppealClicked
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sheet_dist_index_esm/* Sheet */.yo, {
        isOpen: isOpen,
        onClose: setIsOpen,
        animationDuration: {
            enter: 0,
            exit: isAppealClicked ? 0 : 300
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sheet_dist_index_esm/* SheetOverlay */.lu, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(sheet_dist_index_esm/* SheetContent */.ue, {
                className: "max-w-xl m-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sheet_dist_index_esm/* SheetTitle */.bC, {
                        bordered: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                            variant: "heading-sm",
                            children: "Perbaikan"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sheet_dist_index_esm/* SheetCloseButton */.Sv, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(sheet_dist_index_esm/* SheetBody */.Fm, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "border border-subdued rounded m-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                        className: "px-4 py-5 pb-3",
                                        dangerouslySetInnerHTML: {
                                            __html: (0,utils_text/* removeTagsStyleAttribute */.lz)((0,utils_text/* nl2br */.hU)(revisionMessage))
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "p-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.z, {
                                            "data-testid": "fix-button",
                                            color: "black",
                                            fullWidth: true,
                                            size: "lg",
                                            onClick: function() {
                                                return onClickFix();
                                            },
                                            children: "Perbaiki Aksi Nyata"
                                        })
                                    })
                                ]
                            }),
                            isAppealEligible && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-4 text-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                        children: "Merasa saran perbaikan ini keliru dan ingin Aksi Nyata Anda divalidasi ulang?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pt-2 pb-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                            "data-testid": "appeal-button",
                                            onClick: function() {
                                                setAppealClicked(true);
                                                onClickAppeal();
                                            },
                                            underline: true,
                                            variant: "primary",
                                            children: "Ajukan banding"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CertificateSheet_RevisionSheet = (RevisionSheet);

// EXTERNAL MODULE: ./node_modules/@wartek-id/textarea/dist/index.esm.js + 1 modules
var textarea_dist_index_esm = __webpack_require__(32036);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Certificate/CertificateSheet/AppealSheet.tsx












var AppealSheet = function(param) {
    var appeal = param.appeal, isOpen = param.isOpen, setIsOpen = param.setIsOpen, onAppealSubmitted = param.onAppealSubmitted;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), appealText = ref[0], setAppealText = ref[1];
    var router = (0,next_router.useRouter)();
    var topicId = router.query.topik;
    var ref1 = (0,useAPITopics/* usePostAksiNyataAppeal */.Ti)(topicId, {
        onSuccess: function() {
            return onAppealSubmitted();
        }
    }), postAksiNyataMutateAsync = ref1.mutateAsync, isLoading = ref1.isLoading;
    var handleSubmitAppeal = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // if appeal state is not NotCreated or Declined, then forbid submit
                        if (![
                            microlearning/* AppealState.NotCreated */.Z6.NotCreated,
                            microlearning/* AppealState.Declined */.Z6.Declined
                        ].includes(appeal.state)) return [
                            2
                        ];
                        return [
                            4,
                            postAksiNyataMutateAsync({
                                appeal: appealText
                            })
                        ];
                    case 1:
                        _state.sent();
                        setIsOpen(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmitAppeal() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(sheet_dist_index_esm/* Sheet */.yo, {
        isOpen: isOpen,
        onClose: setIsOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sheet_dist_index_esm/* SheetOverlay */.lu, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(sheet_dist_index_esm/* SheetContent */.ue, {
                className: "max-w-xl m-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sheet_dist_index_esm/* SheetTitle */.bC, {
                        bordered: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                            variant: "heading-sm",
                            children: "Pengajuan Banding"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sheet_dist_index_esm/* SheetCloseButton */.Sv, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sheet_dist_index_esm/* SheetBody */.Fm, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "p-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                    children: "Mengapa Anda tidak setuju dengan saran perbaikan ini?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(textarea_dist_index_esm/* Textarea */.g, {
                                    "data-testid": "textarea",
                                    className: "mt-1 mb-4",
                                    placeholder: "Contoh: Mengenai saran agar saya menyertakan umpan balik. Saya tidak setuju karena saya telah menyertakan umpan balik dalam bentuk tautan. Mohon dicek ulang.",
                                    value: appealText,
                                    onChange: function(e) {
                                        setAppealText(e.target.value);
                                    },
                                    maxLength: 500
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.z, {
                                    "data-testid": "submit-button",
                                    color: "black",
                                    fullWidth: true,
                                    size: "lg",
                                    onClick: handleSubmitAppeal,
                                    disabled: appealText === "" || isLoading,
                                    children: "Ajukan banding"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CertificateSheet_AppealSheet = (AppealSheet);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Certificate/CertificateStatusCard.helpers.tsx



var CardButtonVariant;
(function(CardButtonVariant) {
    CardButtonVariant["White"] = "white";
    CardButtonVariant["Black"] = "black";
})(CardButtonVariant || (CardButtonVariant = {}));
var CARD_DATA_CERTIFICATE_NOT_AVAILABLE = {
    iconBackground: "bg-icon-disabled",
    badgeText: "Sertifikat dalam proses",
    cardElement: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Begitu selesai diproses, sertifikat Anda akan muncul di sini"
        });
    },
    buttonText: "",
    buttonVariant: CardButtonVariant.White
};
var CARD_DATA_NO_AKSI_NYATA = {
    iconBackground: "bg-icon-disabled",
    badgeText: "Belum Tersedia",
    cardElement: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Kumpulkan lembar Aksi Nyata Anda agar dapat divalidasi dan berkesempatan memperoleh sertifikat"
        });
    },
    buttonText: "",
    buttonVariant: CardButtonVariant.White
};
var CARD_DATA_CERTIFICATE_DONE = {
    iconBackground: "bg-icon-informational",
    badgeText: "Sertifikat Tersedia",
    cardElement: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Sertifikat Anda sudah dapat diunduh"
        });
    },
    buttonText: "Lihat sertifikat",
    buttonVariant: CardButtonVariant.Black
};
var CARD_DATA_REVISION_DECLINED = {
    iconBackground: "bg-icon-disabled",
    badgeText: "Hasil banding: Perbaiki Aksi Nyata",
    cardElement: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Setelah divalidasi ulang, Aksi Nyata Anda masih perlu diperbaiki. Silakan perbaiki sesuai saran untuk memperoleh sertifikat."
        });
    },
    buttonText: "Baca saran perbaikan",
    buttonVariant: CardButtonVariant.White
};
var CARD_DATA_REVISION_NEEDED = {
    iconBackground: "bg-icon-disabled",
    badgeText: "Perbaiki Aksi Nyata",
    cardElement: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Silakan perbaiki Aksi Nyata sesuai saran perbaikan untuk memperoleh sertifikat"
        });
    },
    buttonText: "Baca saran perbaikan",
    buttonVariant: CardButtonVariant.White
};
var CARD_DATA_WAITING_VALIDATION = {
    iconBackground: "bg-icon-disabled",
    badgeText: "Menunggu Hasil Validasi",
    cardElement: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Proses validasi membutuhkan waktu lebih lama karena Aksi Nyata yang masuk cukup banyak. Mohon kesabaran Anda."
        });
    },
    buttonText: "Pahami proses validasi",
    buttonVariant: CardButtonVariant.White
};
var CARD_DATA_WAITING_APPEAL = {
    iconBackground: "bg-icon-disabled",
    badgeText: "Menunggu Hasil Banding",
    cardElement: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Aksi Nyata Anda sedang divalidasi ulang. Cek halaman ini secara berkala untuk melihat hasilnya."
        });
    },
    buttonText: "Pahami proses validasi",
    buttonVariant: CardButtonVariant.White
};
var getCardDataValues = function(cardState, appealState, isCertifiable) {
    if (cardState === microlearning/* AksiNyataSessionState.Validated */.OZ.Validated && !isCertifiable) return CARD_DATA_CERTIFICATE_NOT_AVAILABLE;
    if (cardState === microlearning/* AksiNyataSessionState.Validated */.OZ.Validated) return CARD_DATA_CERTIFICATE_DONE;
    if (cardState === microlearning/* AksiNyataSessionState.NeedRevision */.OZ.NeedRevision && appealState === microlearning/* AppealState.Declined */.Z6.Declined) return CARD_DATA_REVISION_DECLINED;
    if (cardState === microlearning/* AksiNyataSessionState.NeedRevision */.OZ.NeedRevision) return CARD_DATA_REVISION_NEEDED;
    if (cardState === microlearning/* AksiNyataSessionState.Completed */.OZ.Completed) return CARD_DATA_WAITING_VALIDATION;
    if (cardState === microlearning/* AksiNyataSessionState.Appeal */.OZ.Appeal) return CARD_DATA_WAITING_APPEAL;
    return CARD_DATA_NO_AKSI_NYATA;
};

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Certificate/CertificateStatusCard.tsx
/* provided dependency */ var CertificateStatusCard_process = __webpack_require__(83454);



















var StatusCardState;
(function(StatusCardState) {
    StatusCardState["RevisionCard"] = "REVISION";
    StatusCardState["AppealCard"] = "APPEAL";
    StatusCardState["Closed"] = "";
})(StatusCardState || (StatusCardState = {}));
var CertificateStatusCard = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var toast = (0,toast_dist_index_esm/* useToast */.pm)();
    var isDesktop = (0,useScreenSizeContext/* useScreenSizeContext */.fl)().isDesktop;
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState(StatusCardState.Closed), 2), isOpen = ref5[0], setIsOpen = ref5[1];
    var router = (0,next_router.useRouter)();
    var topikId = router.query.topik;
    var ref6 = (0,useAPIKeyValue/* useGetKeyPairValue */.q8)(useAPIKeyValue/* MILKvKeys.FAQSertifikatMandiri */.QK.FAQSertifikatMandiri), faqSertifikatMandiriKvData = ref6.data;
    var faqSertifikatMandiriLink = (faqSertifikatMandiriKvData === null || faqSertifikatMandiriKvData === void 0 ? void 0 : (ref = faqSertifikatMandiriKvData.data) === null || ref === void 0 ? void 0 : ref.link) || "#";
    var onAppealSubmitted = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        toast({
                            message: "Pengajuan banding telah dikirim!"
                        });
                        return [
                            4,
                            props.refetchProgress()
                        ];
                    case 1:
                        _state.sent();
                        setIsOpen(StatusCardState.Closed);
                        return [
                            2
                        ];
                }
            });
        });
        return function onAppealSubmitted() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleMainCardButtonClick = function() {
        if (props.state === microlearning/* AksiNyataSessionState.Validated */.OZ.Validated) {
            router.push("/".concat(CertificateStatusCard_process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/topik/").concat(topikId, "/sertifikat"));
            return;
        }
        if (props.state === microlearning/* AksiNyataSessionState.NeedRevision */.OZ.NeedRevision) {
            setIsOpen(StatusCardState.RevisionCard);
            return;
        }
        router.push(faqSertifikatMandiriLink);
    };
    var revisionUrl = "/".concat(CertificateStatusCard_process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/topik/").concat(topikId, "/aksi-nyata/form?").concat((0,query_string/* stringify */.Pz)({
        topik_name: props.topicName
    }));
    var cardData = getCardDataValues(props.state, (ref1 = props.appeal) === null || ref1 === void 0 ? void 0 : ref1.state, props.certifiable);
    var ref7;
    var revisionMessage = ((ref2 = props.appeal) === null || ref2 === void 0 ? void 0 : ref2.state) === microlearning/* AppealState.Declined */.Z6.Declined ? (ref3 = props.appeal) === null || ref3 === void 0 ? void 0 : ref3.review : (ref7 = props.revisionItems[0]) !== null && ref7 !== void 0 ? ref7 : "";
    var isAppealEligible = props.appeal.quota > 0 && [
        microlearning/* AppealState.NotCreated */.Z6.NotCreated,
        microlearning/* AppealState.Declined */.Z6.Declined
    ].includes(props.appeal.state);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-3 my-4 mt-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                        variant: "heading-md",
                        children: "Sertifikat"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: isDesktop ? "grid grid-cols-2 gap-2" : null,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-3 border border-subdued rounded p-4 bg-white mt-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)("flex justify-center flex-shrink-0 items-center w-8 h-8 rounded-full overflow-hidden", cardData.iconBackground),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                                        as: "i",
                                        fontSize: "small",
                                        color: "inverse",
                                        children: "download_outlined"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_dist_index_esm/* Badge */.C, {
                                            className: "mb-2",
                                            children: cardData.badgeText
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                            color: "subdued",
                                            variant: "body-sm",
                                            "data-testid": "card-element",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cardData.cardElement, {})
                                        }),
                                        cardData.buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.z, {
                                            "data-testid": "main-button",
                                            color: cardData.buttonVariant,
                                            fullWidth: true,
                                            size: "md",
                                            className: "mt-4",
                                            onClick: handleMainCardButtonClick,
                                            children: cardData.buttonText
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            ((ref4 = props.revisionItems) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CertificateSheet_RevisionSheet, {
                        isOpen: isOpen === StatusCardState.RevisionCard,
                        onClickAppeal: function() {
                            return setIsOpen(StatusCardState.AppealCard);
                        },
                        onClickFix: function() {
                            return router.push(revisionUrl);
                        },
                        revisionMessage: revisionMessage,
                        setIsOpen: setIsOpen,
                        isAppealEligible: isAppealEligible
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CertificateSheet_AppealSheet, {
                        isOpen: isOpen === StatusCardState.AppealCard,
                        setIsOpen: setIsOpen,
                        appeal: props.appeal,
                        onAppealSubmitted: onAppealSubmitted
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Certificate_CertificateStatusCard = (CertificateStatusCard);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Topic/RKMMBanner.tsx




var RKMMBanner = function() {
    var ref, ref1, ref2, ref3;
    var contributionBanner = (0,useAPIKeyValue/* useGetKeyPairValue */.q8)(useAPIKeyValue/* MILKvKeys.RKMMContributionBanner */.QK.RKMMContributionBanner);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: contributionBanner.isSuccess && ((ref = contributionBanner.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.link) && ((ref2 = contributionBanner.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "px-3",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: contributionBanner.data.data.link,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: contributionBanner.data.data.link,
                    className: "block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: contributionBanner.data.data.image,
                        alt: "Banner program kontribusi perangkat ajar",
                        className: "w-full mx-auto max-w-[428px] h-auto"
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Topic_RKMMBanner = (RKMMBanner);

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(98743);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/timezone.js
var timezone = __webpack_require__(34646);
var timezone_default = /*#__PURE__*/__webpack_require__.n(timezone);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/utc.js
var utc = __webpack_require__(97046);
var utc_default = /*#__PURE__*/__webpack_require__.n(utc);
// EXTERNAL MODULE: ./node_modules/dayjs/locale/id.js
var id = __webpack_require__(23260);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/pages/TopicDetails.helper.WebinarEntries.ts




dayjs_min_default().extend((utc_default()));
dayjs_min_default().extend((timezone_default()));
dayjs_min_default().locale("id");
var filterByModuleTopicId = function(webinarEntries, currentTopicId) {
    return webinarEntries.filter(function(webinarEntry) {
        var modulesTopicIds = webinarEntry.module.map(function(module) {
            return module.topikId;
        });
        if (modulesTopicIds.includes(currentTopicId)) return webinarEntry;
    });
};
var WIB_TIME = dayjs_min_default()().tz("Asia/Jakarta");
var MINUTES_CUTOFF_FILTER = 30;
var filterByDate = function(webinarEntries) {
    return webinarEntries.filter(function(webinarEntry) {
        return WIB_TIME.isBefore(dayjs_min_default()(webinarEntry.endDate).add(MINUTES_CUTOFF_FILTER, "minute"));
    });
};
var sortByDate = function(webinarEntries) {
    return webinarEntries.sort(function(a, b) {
        var aStartDate = dayjs_min_default()(a.startDate);
        var bStartDate = dayjs_min_default()(b.startDate);
        if (aStartDate.isBefore(bStartDate)) return -1;
        if (aStartDate.isAfter(bStartDate)) return 1;
        return 0;
    });
};

// EXTERNAL MODULE: ./app/PelatihanMandiriPage/hooks/useSETrackEvent.ts + 2 modules
var useSETrackEvent = __webpack_require__(35917);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/components/CertificateTopic.tsx







var CertificateTopic = function(param) {
    var progressData = param.progressData;
    var isAllPassed = progressData === null || progressData === void 0 ? void 0 : progressData.modules.every(function(module) {
        return (module === null || module === void 0 ? void 0 : module.postTest) === "passed";
    });
    var CARD_STATE = {
        passed: {
            iconBackground: "bg-icon-informational",
            badgeText: "Tersedia",
            infoText: "Unduh surat keterangan selesai topik pelatihan mandiri.",
            buttonUrl: "/pelatihan-mandiri/topik/".concat(progressData === null || progressData === void 0 ? void 0 : progressData.id, "/surat-selesai-belajar")
        },
        "not-passed": {
            iconBackground: "bg-icon-disabled",
            badgeText: "Belum Tersedia",
            infoText: "Selesaikan semua modul untuk mendapatkan surat keterangan selesai topik pelatihan mandiri",
            buttonUrl: ""
        }
    };
    var ref = isAllPassed ? CARD_STATE.passed : CARD_STATE["not-passed"], iconBackground = ref.iconBackground, badgeText = ref.badgeText, infoText = ref.infoText, buttonUrl = ref.buttonUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-3 mt-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                variant: "heading-md",
                children: "Surat Keterangan Selesai Topik"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-3 border border-subdued rounded p-4 bg-white mt-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("flex justify-center flex-shrink-0 items-center w-8 h-8 rounded-full overflow-hidden", iconBackground),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                            as: "i",
                            fontSize: "small",
                            color: "inverse",
                            children: "download_outlined"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(badge_dist_index_esm/* Badge */.C, {
                                className: "mb-2",
                                children: badgeText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                color: "subdued",
                                variant: "body-sm",
                                "data-testid": "card-element",
                                children: infoText
                            }),
                            buttonUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: buttonUrl,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.z, {
                                    color: "black",
                                    fullWidth: true,
                                    size: "md",
                                    className: "mt-4",
                                    children: "Unduh Surat"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CertificateTopic = (CertificateTopic);

// EXTERNAL MODULE: ./app/PelatihanMandiriPage/components/TopicSpeedDropdown.module.css
var TopicSpeedDropdown_module = __webpack_require__(35398);
var TopicSpeedDropdown_module_default = /*#__PURE__*/__webpack_require__.n(TopicSpeedDropdown_module);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/components/TopicSpeedDropdown.tsx







var TopicSpeedDropdown = function(param) {
    var genericInfo = param.genericInfo, aksiNyata = param.aksiNyata, pelajariSemuaModul = param.pelajariSemuaModul, rekomendasiPenyelesaianTopik = param.rekomendasiPenyelesaianTopik;
    var ref = (0,react.useState)(false), expanded = ref[0], setExpanded = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: (0,clsx_m/* default */.Z)("flex flex-col bg-white overflow-hidden"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: "flex items-center p-[14px]",
                onClick: function() {
                    return setExpanded(!expanded);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                        fontSize: "small",
                        children: "info_outlined"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_dist_index_esm/* Text */.x, {
                        variant: "helper-bold",
                        className: "flex-1 ml-[14px]",
                        children: [
                            "Rekomendasi penyelesaian topik: ",
                            rekomendasiPenyelesaianTopik
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (0,clsx_m/* default */.Z)("flex items-center", (TopicSpeedDropdown_module_default()).button, expanded && "rotate-180"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                            fontSize: "small",
                            children: "keyboard_arrow_down"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (0,clsx_m/* default */.Z)("px-4 pt-0", expanded ? (TopicSpeedDropdown_module_default())["section-expanded"] : (TopicSpeedDropdown_module_default())["section-collapsed"]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                        variant: "body-sm",
                        dangerouslySetInnerHTML: {
                            __html: (0,utils_text/* removeTagsStyleAttribute */.lz)(genericInfo)
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                        as: "div",
                        variant: "body-sm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                            className: "list-decimal pl-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        "Pelajari semua modul (",
                                        pelajariSemuaModul,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        "Melakukan aksi nyata (",
                                        aksiNyata,
                                        ")"
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_TopicSpeedDropdown = (TopicSpeedDropdown);

// EXTERNAL MODULE: ./app/PelatihanMandiriPage/components/InfoUpdatedTopic.tsx
var InfoUpdatedTopic = __webpack_require__(34311);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Topic/TopicInfo.tsx









var TopicInfo = function(param) {
    var pointers = param.pointers, shouldShowTab = param.shouldShowTab, _shouldShowInfo = param.shouldShowInfo, shouldShowInfo = _shouldShowInfo === void 0 ? true : _shouldShowInfo, isTopicUpdated = param.isTopicUpdated;
    var ref;
    var query = (0,next_router.useRouter)().query;
    var ref1;
    var ref2 = (ref1 = (ref = (0,useAPIKeyValue/* useGetKeyPairValue */.q8)(useAPIKeyValue/* MILKvKeys.TopicSpeed */.QK.TopicSpeed).data) === null || ref === void 0 ? void 0 : ref.data) !== null && ref1 !== void 0 ? ref1 : {}, genericInfo = ref2.generic_info, topics = ref2.topics;
    var ref3;
    var recommendations = ((ref3 = topics === null || topics === void 0 ? void 0 : topics.find(function(topicSpeed) {
        return topicSpeed.id === query.topik;
    })) !== null && ref3 !== void 0 ? ref3 : {}).recommendations;
    var flagShowTab = shouldShowTab;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isTopicUpdated && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoUpdatedTopic/* default */.Z, {
                isForceShow: true
            }),
            shouldShowInfo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: ((0,clsx_m/* default */.Z)(flagShowTab ? "pt-4" : "pt-4"), "px-3 mt-4"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("p-4 bg-white border rounded-t border-subdued", !recommendations && "rounded-b"),
                        children: pointers && pointers.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "pl-5 list-disc",
                            children: pointers.map(function(item, idx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                    as: "li",
                                    variant: "body-sm",
                                    children: (0,utils_text/* capitalizeFirstLetter */.fm)(item)
                                }, item + idx);
                            })
                        })
                    }),
                    !!recommendations && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "border border-t-0 rounded-b border-subdued overflow-hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TopicSpeedDropdown, {
                                genericInfo: genericInfo,
                                aksiNyata: recommendations.aksi_nyata,
                                rekomendasiPenyelesaianTopik: recommendations.rekomendasi_penyelesaian_topik,
                                pelajariSemuaModul: recommendations.pelajari_semua_modul
                            })
                        })
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ var Topic_TopicInfo = (TopicInfo);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/pages/TopicDetails.tsx
/* provided dependency */ var TopicDetails_process = __webpack_require__(83454);


























var TopicDetails = function(param) {
    var onPageLoaded = param.onPageLoaded, _isDesktop = param.isDesktop, isDesktop = _isDesktop === void 0 ? false : _isDesktop;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,next_router.useRouter)(), query = ref5.query, back = ref5.back, replace = ref5.replace;
    var topik = query.topik, filter = query.filter;
    var _from = query.from, from = _from === void 0 ? "topik" : _from, _menuId = query.menuId, menuId = _menuId === void 0 ? topik : _menuId;
    var ref6 = hooks_useTopicDetails(topik), moduleWithProgress = ref6.moduleWithProgress, topicData = ref6.topicData, fetchStatus = ref6.fetchStatus, progressionData = ref6.progressionData, revisionItems = ref6.revisionItems, certifiable = ref6.certifiable, appeal = ref6.appeal, refetchProgress = ref6.refetchProgress;
    var isTopicUpdated = topicData === null || topicData === void 0 ? void 0 : topicData.isTopicUpdated;
    var ref7 = (0,react.useState)(true), isAksiNyataLocked = ref7[0], setIsAksiNyataLocked = ref7[1];
    var isDaljabTopic = (topicData === null || topicData === void 0 ? void 0 : topicData.topicType) === "DALJAB";
    var webinarKv = (0,useAPIKeyValue/* useGetKeyPairValue */.q8)(useAPIKeyValue/* MILKvKeys.WebinarEntries */.QK.WebinarEntries, !!fetchStatus, {
        select: function(data) {
            return {
                data: sortByDate(filterByDate(filterByModuleTopicId(data.data.webinar, parseInt("".concat(topik), 10)))).shift(),
                meta: {}
            };
        }
    });
    var SETrackTopicList = (0,useSETrackEvent/* useSETrackerEvent */.L)().SETrackTopicList;
    var handleTracker = function(id) {
        if (filter) {
            SETrackTopicList({
                action_type: "choose_module",
                action_filter: filter,
                topic_id: id
            });
        }
    };
    // Determine if aksinyata is locked or not
    (0,react.useEffect)(function() {
        if (fetchStatus === "success") {
            var topicState = (0,helper/* determineTopicState */.h6)(progressionData);
            var optNotLocked = [
                "MODULE_DONE",
                "AKSI_NYATA_CREATED",
                "AKSI_NYATA_ON_PROGRESS",
                "AKSI_NYATA_DONE",
                "AKSI_NYATA_NEED_REVISION",
                "AKSI_NYATA_VALIDATED",
                "AKSI_NYATA_APPEAL", 
            ];
            if (optNotLocked.includes(topicState)) {
                setIsAksiNyataLocked(false);
            }
            // redirect if topicType `DALJAB`
            if (isDaljabTopic) {
                replace("/pelatihan-mandiri/404");
            }
        }
        onPageLoaded === null || onPageLoaded === void 0 ? void 0 : onPageLoaded(topicData === null || topicData === void 0 ? void 0 : topicData.name);
    }, [
        progressionData,
        fetchStatus,
        onPageLoaded,
        topicData === null || topicData === void 0 ? void 0 : topicData.name,
        isDaljabTopic,
        replace, 
    ]);
    var TopicContent = function() {
        var ref, ref1, ref2, ref3, ref4;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Topic_TopicInfo, {
                        isTopicUpdated: isTopicUpdated,
                        pointers: topicData === null || topicData === void 0 ? void 0 : topicData.values,
                        shouldShowTab: Boolean(topicData === null || topicData === void 0 ? void 0 : topicData.contextualizedPageId)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericList/* default */.Z, {
                        className: "relative px-3",
                        beforeList: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                webinarKv.isSuccess && !!((ref = webinarKv.data) === null || ref === void 0 ? void 0 : ref.data) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mb-2 flex justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                                    variant: "heading-md",
                                                    children: "Webinar"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/".concat(TopicDetails_process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/webinar"),
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                                        as: "a",
                                                        variant: "body-sm",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            className: "text-blue-70",
                                                            children: "Lihat Jadwal Lain"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)("mb-4 last:mb-0", isDesktop && "grid grid-cols-2 gap-2"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebinarCard/* default */.Z, {
                                                id: webinarKv.data.data.id,
                                                href: "/".concat(TopicDetails_process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/webinar/").concat((ref1 = webinarKv.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.id),
                                                topicName: (ref3 = webinarKv.data.data.topic) === null || ref3 === void 0 ? void 0 : ref3.title,
                                                topicId: (ref4 = webinarKv.data.data.topic) === null || ref4 === void 0 ? void 0 : ref4.id,
                                                title: webinarKv.data.data.title,
                                                speakers: webinarKv.data.data.speakers,
                                                startDate: webinarKv.data.data.startDate,
                                                endDate: webinarKv.data.data.endDate
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-2 mt-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                            variant: "heading-md",
                                            children: "Modul Pelatihan"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                            variant: "body",
                                            color: "subdued",
                                            children: "Silakan pelajari modul sesuai urutan"
                                        })
                                    ]
                                })
                            ]
                        }),
                        data: moduleWithProgress,
                        dataState: isDaljabTopic ? "loading" : fetchStatus,
                        loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pt-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Module_ModulePlaceholder, {
                                amount: 3
                            })
                        }),
                        emptyComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyState */.ub, {
                            title: "Konten belum tersedia",
                            description: "Belum ada topik yang dapat dipelajari saat ini, silahkan coba lagi nanti."
                        }),
                        renderItem: function(param, index) {
                            var id = param.id, name = param.name, duration = param.duration, totalMaterial = param.totalMaterial, progress = param.progress, badgeText = param.badgeText;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    return handleTracker(id);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Module_ModuleCard, {
                                    id: id,
                                    number: index + 1,
                                    name: name,
                                    duration: duration,
                                    totalMaterial: totalMaterial,
                                    isLocked: !(progress === null || progress === void 0 ? void 0 : progress.prerequisiteCompleted),
                                    isCompleted: (progress === null || progress === void 0 ? void 0 : progress.postTest) === "passed",
                                    badgeText: badgeText,
                                    href: "/".concat(TopicDetails_process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/modul/").concat(id, "?") + (0,query_string/* stringify */.Pz)({
                                        topik: query.topik,
                                        topik_name: topicData === null || topicData === void 0 ? void 0 : topicData.name,
                                        from: from,
                                        menuId: menuId
                                    })
                                })
                            });
                        },
                        listKey: function(param) {
                            var id = param.id;
                            return id;
                        },
                        itemWrapperClassName: isDesktop && "grid grid-cols-2 gap-2"
                    })
                ]
            })
        });
    };
    if (isDesktop) {
        var ref8, ref9, ref10, ref11, ref12;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            "Pelatihan Mandiri | Topik ",
                            topicData === null || topicData === void 0 ? void 0 : topicData.name
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row",
                    children: [
                        query.from && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                            as: "i",
                            color: "default",
                            className: "mr-2",
                            onClick: back,
                            children: "arrow_back"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                    className: (0,clsx_m/* default */.Z)("pb-1"),
                                    children: "TOPIK"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                    className: (0,clsx_m/* default */.Z)("pb-3"),
                                    variant: "heading-lg",
                                    children: topicData === null || topicData === void 0 ? void 0 : topicData.name
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bg-white rounded-lg shadow-md p-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TopicHeader/* default */.Z, {
                            title: topicData === null || topicData === void 0 ? void 0 : topicData.name,
                            shouldShowTab: Boolean(topicData === null || topicData === void 0 ? void 0 : topicData.contextualizedPageId),
                            shouldShowInfo: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "sticky top-[54px] z-10 px-8 py-3 h-24 -mx-3 bg-gray-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Topic_ProgressionBar, {
                                        progressData: progressionData
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative mb-4 -mx-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "border-subdued"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TopicContent, {}),
                        fetchStatus === "success" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative px-3 z-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AksiNyata_AksiNyataCard, {
                                topikId: query.topik,
                                name: topicData === null || topicData === void 0 ? void 0 : topicData.name,
                                selectedOptionTitle: progressionData === null || progressionData === void 0 ? void 0 : (ref8 = progressionData.aksiNyata) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.selectedOption) === null || ref9 === void 0 ? void 0 : ref9.title,
                                optionsAmount: topicData === null || topicData === void 0 ? void 0 : topicData.aksiNyataOptionCount,
                                aksiNyataSessionState: progressionData === null || progressionData === void 0 ? void 0 : (ref10 = progressionData.aksiNyata) === null || ref10 === void 0 ? void 0 : ref10.state,
                                isLocked: isAksiNyataLocked,
                                aksiNyataId: progressionData === null || progressionData === void 0 ? void 0 : (ref11 = progressionData.aksiNyata) === null || ref11 === void 0 ? void 0 : ref11.id
                            })
                        }),
                        fetchStatus === "success" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Certificate_CertificateStatusCard, {
                            state: progressionData === null || progressionData === void 0 ? void 0 : (ref12 = progressionData.aksiNyata) === null || ref12 === void 0 ? void 0 : ref12.state,
                            revisionItems: revisionItems || [],
                            topicName: topicData === null || topicData === void 0 ? void 0 : topicData.name,
                            certifiable: certifiable,
                            appeal: appeal,
                            refetchProgress: refetchProgress
                        }),
                        !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(Topic_RKMMBanner, {})
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        "Pelatihan Mandiri | Topik ",
                        topicData === null || topicData === void 0 ? void 0 : topicData.name
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative pb-6 bg-gray-10 z-0",
                style: {
                    minHeight: (0,helper/* shouldHideNav */.J8)() ? "100vh" : "calc(100vh - 3.5rem)"
                },
                children: [
                    !(0,helper/* shouldHideNav */.J8)() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sticky top-[54px] z-30",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopicHeader/* default */.Z, {
                                title: topicData === null || topicData === void 0 ? void 0 : topicData.name,
                                shouldShowTab: Boolean(topicData === null || topicData === void 0 ? void 0 : topicData.contextualizedPageId)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "hidden",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "sticky top-[54px] z-10 px-8 py-3 h-24 -mx-3 bg-gray-5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Topic_ProgressionBar, {
                                            progressData: progressionData
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative mb-4 -mx-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                            className: "border-subdued"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopicContent, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CertificateTopic, {
                        progressData: progressionData
                    }),
                    fetchStatus === "success" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative px-3 z-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AksiNyata_AksiNyataCard, {
                            topikId: query.topik,
                            name: topicData === null || topicData === void 0 ? void 0 : topicData.name,
                            selectedOptionTitle: progressionData === null || progressionData === void 0 ? void 0 : (ref = progressionData.aksiNyata) === null || ref === void 0 ? void 0 : (ref1 = ref.selectedOption) === null || ref1 === void 0 ? void 0 : ref1.title,
                            optionsAmount: topicData === null || topicData === void 0 ? void 0 : topicData.aksiNyataOptionCount,
                            aksiNyataSessionState: progressionData === null || progressionData === void 0 ? void 0 : (ref2 = progressionData.aksiNyata) === null || ref2 === void 0 ? void 0 : ref2.state,
                            isLocked: isAksiNyataLocked,
                            aksiNyataId: progressionData === null || progressionData === void 0 ? void 0 : (ref3 = progressionData.aksiNyata) === null || ref3 === void 0 ? void 0 : ref3.id
                        })
                    }),
                    fetchStatus === "success" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Certificate_CertificateStatusCard, {
                        state: progressionData === null || progressionData === void 0 ? void 0 : (ref4 = progressionData.aksiNyata) === null || ref4 === void 0 ? void 0 : ref4.state,
                        revisionItems: revisionItems || [],
                        topicName: topicData === null || topicData === void 0 ? void 0 : topicData.name,
                        certifiable: certifiable,
                        appeal: appeal,
                        refetchProgress: refetchProgress
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Topic_RKMMBanner, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_TopicDetails = (TopicDetails);

// EXTERNAL MODULE: ./utils/customError.ts
var customError = __webpack_require__(97512);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/hooks/useShowSocialDrawer.tsx
var useShowSocialDrawer = __webpack_require__(40932);
// EXTERNAL MODULE: ./components/Layout/Desktop/DesktopLayout.tsx
var DesktopLayout = __webpack_require__(72351);
;// CONCATENATED MODULE: ./pages/pelatihan-mandiri/topik/[topik]/index.tsx

















var TopikPage = function(props) {
    var isDesktopScreenSize = props.isDesktopScreenSize;
    var router = (0,next_router.useRouter)();
    var shareText = (0,react.useRef)("");
    var ref = (0,useShowSocialDrawer/* default */.Z)({
        drawerTitle: "Bagikan Topik",
        shareText: shareText.current
    }), triggerShareDialog = ref.triggerShareDialog, Drawer = ref.Drawer;
    var handlePageLoaded = (0,react.useCallback)(function(topicName) {
        shareText.current = "Ibu/Bapak Guru, ".concat(!!topicName ? "ini topik ".concat(topicName) : "ada topik pelatihan", " di platform Merdeka Mengajar. Silakan cek di tautan berikut: ").concat(window.location.href);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_error_boundary_umd.ErrorBoundary, {
        resetKeys: [
            router.asPath
        ],
        FallbackComponent: function(param) {
            var error = param.error, resetErrorBoundary = param.resetErrorBoundary;
            if ((0,_instanceof/* default */.Z)(error, customError/* NotFoundError */.dR) || (0,_instanceof/* default */.Z)(error, useAPITopics/* JenjangUnmatched */.w3)) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PelatihanErrorFallback, {
                    error: error,
                    resetErrorBoundary: resetErrorBoundary
                });
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* CustomErrorFallback */.m, {
                    error: error,
                    resetErrorBoundary: resetErrorBoundary
                });
            }
        },
        children: [
            !(0,helper/* shouldHideNav */.J8)() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HeaderBar */.h_, {
                fixed: true,
                borderless: true,
                className: "z-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HeaderBarLeftAction */.l8, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                            as: "i",
                            color: "default",
                            children: "arrow_back"
                        }),
                        onClick: function() {
                            return dist_history/* backToApp */.NU(router.back);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HeaderBarRightAction */.so, {
                        onClick: triggerShareDialog,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.J, {
                            children: "share"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesktopLayout/* WithLayoutListener */.nc, {
                isDesktop: isDesktopScreenSize,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_TopicDetails, {
                        onPageLoaded: handlePageLoaded,
                        isDesktop: isDesktopScreenSize
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer, {})
                ]
            })
        ]
    });
};
TopikPage.layoutOpts = {
    hasHeader: false,
    className: (0,clsx_m/* default */.Z)("bg-gray-10", !(0,helper/* shouldHideNav */.J8)() && "mt-[54px]"),
    enableDesktopLayout: true
};
/* harmony default export */ var _topik_ = (TopikPage);


/***/ }),

/***/ 35398:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"TopicSpeedDropdown_button__TOkIQ","section-expanded":"TopicSpeedDropdown_section-expanded__jdwJb","section-collapsed":"TopicSpeedDropdown_section-collapsed__uXQ4o"};

/***/ }),

/***/ 97334:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={815:function(e){function hasOwnProperty(e,r){return Object.prototype.hasOwnProperty.call(e,r)}e.exports=function(e,n,t,o){n=n||"&";t=t||"=";var a={};if(typeof e!=="string"||e.length===0){return a}var i=/\+/g;e=e.split(n);var u=1e3;if(o&&typeof o.maxKeys==="number"){u=o.maxKeys}var c=e.length;if(u>0&&c>u){c=u}for(var p=0;p<c;++p){var f=e[p].replace(i,"%20"),s=f.indexOf(t),_,l,y,d;if(s>=0){_=f.substr(0,s);l=f.substr(s+1)}else{_=f;l=""}y=decodeURIComponent(_);d=decodeURIComponent(l);if(!hasOwnProperty(a,y)){a[y]=d}else if(r(a[y])){a[y].push(d)}else{a[y]=[a[y],d]}}return a};var r=Array.isArray||function(e){return Object.prototype.toString.call(e)==="[object Array]"}},577:function(e){var stringifyPrimitive=function(e){switch(typeof e){case"string":return e;case"boolean":return e?"true":"false";case"number":return isFinite(e)?e:"";default:return""}};e.exports=function(e,t,o,a){t=t||"&";o=o||"=";if(e===null){e=undefined}if(typeof e==="object"){return map(n(e),(function(n){var a=encodeURIComponent(stringifyPrimitive(n))+o;if(r(e[n])){return map(e[n],(function(e){return a+encodeURIComponent(stringifyPrimitive(e))})).join(t)}else{return a+encodeURIComponent(stringifyPrimitive(e[n]))}})).join(t)}if(!a)return"";return encodeURIComponent(stringifyPrimitive(a))+o+encodeURIComponent(stringifyPrimitive(e))};var r=Array.isArray||function(e){return Object.prototype.toString.call(e)==="[object Array]"};function map(e,r){if(e.map)return e.map(r);var n=[];for(var t=0;t<e.length;t++){n.push(r(e[t],t))}return n}var n=Object.keys||function(e){var r=[];for(var n in e){if(Object.prototype.hasOwnProperty.call(e,n))r.push(n)}return r}}};var r={};function __nccwpck_require__(n){var t=r[n];if(t!==undefined){return t.exports}var o=r[n]={exports:{}};var a=true;try{e[n](o,o.exports,__nccwpck_require__);a=false}finally{if(a)delete r[n]}return o.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var n={};!function(){var e=n;e.decode=e.parse=__nccwpck_require__(815);e.encode=e.stringify=__nccwpck_require__(577)}();module.exports=n})();

/***/ }),

/***/ 25934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1958,8189,3303,5370,2627,4088,1547,8703,1529,7882,8085,586,9774,2888,179], function() { return __webpack_exec__(18631); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);